import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Typography,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { useTranslation } from "react-i18next";

type PlanCardProps = {
  planID: number;
  name: string;
  content: string[];
  price: string;
  color?: string;
  perks?: string[];
};

export function PlanCard(props: PlanCardProps) {
  const { t } = useTranslation(["common, upgrade"]);
  var contents = props.content.map((content) => {
    return (
      <Typography variant="subtitle1" textAlign={"left"}>
        <CheckIcon color="success" /> {content}
      </Typography>
    );
  });
  return (
    <Card
      style={{ marginTop: "20px", minHeight: "500px", position: "relative" }}
      className="minor-scale-up-hover"
    >
      <CardHeader
        title={props.name}
        titleTypographyProps={{ fontWeight: "500", textTransform: "uppercase" }}
        style={{
          width: "100%",
          backgroundColor: props.color ? props.color : "#81d4fa",
          filter: "brightness(95%)",
          fontWeight: "600",
        }}
      ></CardHeader>
      <CardContent>
        <Typography variant="h5">{props.price}</Typography>
        <div style={{ marginTop: "10px" }}>{contents}</div>
      </CardContent>
      <CardActions style={{ padding: "10px" }}>
        <Button
          variant="contained"
          style={{
            position: "absolute",
            bottom: "60px",
            left: "15px",
            right: "15px",
            backgroundColor: props.color ? props.color : "#81d4fa",
            opacity: "0.75",
            color: "white",
          }}
        >
          {t("plan:Demo")}
        </Button>
        <Button
          variant="contained"
          style={{
            position: "absolute",
            bottom: "10px",
            left: "15px",
            right: "15px",
            marginLeft: "0px",
            backgroundColor: props.color ? props.color : "#81d4fa",
            color: "white",
          }}
        >
          {t("upgrade:purchase_now")}
        </Button>
      </CardActions>
    </Card>
  );
}
